import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteSupplier, fetchSuppliers } from "../../../slices/company/supplierSlice";
import DataTable from "react-data-table-component"; // Assuming you are using 'react-data-table-component'
import { Link } from "react-router-dom";
import { Delete, Pen } from "lucide-react";
import Swal from "sweetalert2";
import AddEditSupplier from "./supplier_form";
import { customTableStyles } from "../../../utils/tableStylings";

const SupplierList = () => {
    const dispatch = useDispatch();
    const { suppliers = [], loading, error } = useSelector((state) => state.suppliers);
    const [search, setSearch] = useState(""); // To store the search input
    const [showModal, setShowModal] = useState(false); // To control modal visibility
    const [selectedSupplier, setSelectedSupplier] = useState([]);


    const handleAddSupplier = () => {
        setSelectedSupplier([]); // No supplier means we are adding a new one
        setShowModal(true);
    };

    const handleEditSupplier = (supplierData) => {
        setSelectedSupplier(supplierData); // Pass the supplier data to edit
        setShowModal(true);
    };


    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            dispatch(fetchSuppliers(company.company?.id));
        }
    }, [dispatch]);

    // Filter suppliers based on the search input
    const filteredSuppliers = suppliers?.length
        ? suppliers.filter((supplier) => {
            const searchText = (search || '').toLowerCase();

            return (
                (supplier?.name || '').toLowerCase().includes(searchText) ||
                (supplier?.email || '').toLowerCase().includes(searchText) ||
                (supplier?.mobile_no || '').toLowerCase().includes(searchText)
            );
        })
        : [];




    const handleDelete = (branchId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this Suppliers.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteSupplier(branchId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Supplier has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });

            }
        });

    };


    // Define the columns for the DataTable
    const columns = [
        {
            name: "#",
            selector: (row, index) => index + 1, // Display row index (1-based)
            sortable: false,
            width: "50px", // Optional: Set the width of the column
        },
        {
            name: "Firm Name / Trade Name", // Update to "Supplier Name"
            selector: (row) => row.name, // Assuming row has a 'name' property
            sortable: true,
            width: "350px",
        },

        {
            name: "Mobile No",
            selector: (row) => row.mobile_no || 'N/A', // Assuming row has a 'mobile_no' property
            sortable: true,
        },

        {
            name: "Billing Name",
            selector: (row) => row.billing_name || 'N/A', // Assuming row has a 'city' property
        },
        {
            name: "Billing Phone",
            selector: (row) => row.billing_phone || 'N/A', // Assuming row has a 'state' property
        },

        {
            name: "Actions",
            cell: (row) => (
                <div>
                    <span className="text-warning cursor-pointer me-3" onClick={() => handleEditSupplier(row)}>
                        <Pen />
                    </span>
                    <span className="text-danger  cursor-pointer" onClick={() => handleDelete(row.id)}>
                        <Delete />
                    </span>
                </div>
            ),
            ignoreRowClick: true,
            width: "100px", //
        },
    ];

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center gap-2">
                            <h3 className="text-primary">Suppliers</h3>
                            <span className="d-flex align-items-center gap-2">
                                <input
                                    type="text"
                                    placeholder="Search Suppliers"
                                    className="form-control"
                                    value={search}
                                    style={{ width: "220px" }}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <button type="button" onClick={handleAddSupplier} className="btn btn-primary">Add New</button>
                            </span>
                        </div>
                        

                        <div className="card-body">

                            {error && <p className="text-danger">Error: {error}</p>}
                            <div className="table-responsive">
                                <DataTable
                                    className="table-hover custom-table"
                                    columns={columns}
                                    data={filteredSuppliers} // Use filtered data
                                    pagination
                                    striped
                                    progressPending={loading}
                                    customStyles={customTableStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddEditSupplier show={showModal} onClose={() => setShowModal(false)} supplierData={selectedSupplier} />
        </>
    );
};

export default SupplierList;
